export interface AppViewProps {
  children: React.ReactNode;
}

function PublicLayout({ children }: AppViewProps) {
  return <>{children}</>;
}
export default PublicLayout;
